import { render } from "./OfferFilterInput.vue?vue&type=template&id=063d266e"
import script from "./OfferFilterInput.vue?vue&type=script&lang=js"
export * from "./OfferFilterInput.vue?vue&type=script&lang=js"
script.render = render

export default script